import { useAuth0 } from '@auth0/auth0-react';
export function useAuth() {
  const a = useAuth0();
  return {
    user: a.user,
    isAuthenticated: a.isAuthenticated,
    isLoading: a.isLoading,
    login: () => a.loginWithRedirect(),
    logout: () => a.logout({ logoutParams: { returnTo: window.location.origin } }),
    getAccessToken: () => a.getAccessTokenSilently(),
  };
}
